module.exports = require("./bn-IN.d.ts");